import { render, staticRenderFns } from "./UserWrapper.vue?vue&type=template&id=935bf004"
import script from "./UserWrapper.vue?vue&type=script&lang=js"
export * from "./UserWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('935bf004')) {
      api.createRecord('935bf004', component.options)
    } else {
      api.reload('935bf004', component.options)
    }
    module.hot.accept("./UserWrapper.vue?vue&type=template&id=935bf004", function () {
      api.rerender('935bf004', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user/UserWrapper.vue"
export default component.exports